module.exports = __webpack_public_path__ + "static/downpaymentAssistanceBg-70f0db0bd691e85b1271a4e8e4ab4769.jpg";